import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, unref as _unref } from "vue"

import { ref, watch } from 'vue'
import { queryReportDataPage } from '@/api'
import { CODE_ENUM, PAGE_SIZES } from '@/common'
import moment from 'moment'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'report-data',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;




const getTitle = () => {
  return props.data?.reportName
}

const columns: any = ref([])
const tableData = ref([])
const total = ref(0)

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      fetchList()
    }
  }
)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const tableLoading = ref(false)
const fetchList = async () => {
  tableLoading.value = true
  const res: any = await queryReportDataPage({
    ...pageParams.value,
    id: props.data?.id,
  }).finally(() => {
    tableLoading.value = false
  })

  if (res?.code === CODE_ENUM.SUCCESS) {
    const { tableColumn } = res.data || {}

    total.value = res?.data?.total || 0
    tableData.value = res?.data?.tableData || []
    columns.value = tableColumn || []
  } else if (res?.code === 30900) {
    // 数据透传
    total.value = 0
    tableData.value = []
  }
}

const handleClose = () => {
  total.value = 0
  tableData.value = []
  pageParams.value = {
    curPage: 1,
    pageSize: 10,
  }
  $emit('update:visible')
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: getTitle(),
    width: "1200",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        class: "ws_common_table"
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, {
            description: _ctx.$t('STATISTICS.noData')
          }, null, 8, ["description"])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
              key: item.prop
            }, {
          ...item,
        }), null, 16))
          }), 128))
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})